<template>

  <header
      class="navbar navbar-horizontal navbar-expand navbar-dark flex-row align-items-md-center ct-navbar  py-3"
      :class="pageBackgroundColor">
    <a class="navbar-brand mr-0 mr-md-2" href="/">
      <img src="/img/image/common/logo.png" height="40px" loading="lazy" alt="滿香脆">
    </a>
    <div class="d-none d-sm-block ml-auto">
      <ul class="navbar-nav ct-navbar-nav flex-row align-items-center">
        <li class="nav-item">
          <a class="nav-link" href="/#story" rel="nofollow" alt="認識滿香脆">認識滿香脆</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/#store" rel="nofollow" alt="店面資訊">店面資訊</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/join" rel="nofollow" alt="我要加盟">我要加盟</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/search" rel="nofollow" alt="查詢訂單">查詢訂單</a>
        </li>
        <li class="nav-item d-lg-block">
          <a href="/buy" class="btn btn-primary" alt="立即品嚐">
            <span class="nav-link-inner--text">立即品嚐</span>
          </a>
        </li>
      </ul>
    </div>

    <button class="navbar-toggler ct-search-docs-toggle d-block d-sm-none ml-auto ml-sm-0" type="button"
            @click="clickMenu">
      <span class="icon"></span>
    </button>
    <div v-if="isMenuOpen" class="menu-mask" @click="clickMenu">
      <div class="menu-overlay">
        <div class="menu-items">
          <a class="menu_item" href="/#story" alt="認識滿香脆">認識滿香脆</a>
          <a class="menu_item" href="/#store" alt="店面資訊">店面資訊</a>
          <a class="menu_item" href="/join" alt="我要加盟">我要加盟</a>
          <a class="menu_item" href="/search" alt="查詢訂單">查詢訂單</a>
          <a class="menu_item" href="/buy" alt="前往購買">前往購買</a>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import {isEmpty} from "../util/helpers";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  data() {
    return {
      isMenuOpen: false,
      youtube_url: 'https://www.youtube.com/',
      instagram_url: 'https://www.instagram.com/',
      whatsapp_url: '',
    }
  },
  computed: {
    pageBackgroundColor() {
      switch (this.$route.name) {
        case 'buy':
        case 'orderDetail':
          return "bg-white"
        case 'join':
        case 'search':
          return "bg-join"
        default:
          return 'bg-color';
      }
    },
  },
  methods: {
    clickAnchor(target) {
      this.isMenuOpen = false;
    },
    clickMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  }
};
</script>
<style lang="scss" scoped>
.nav-link {
  font-size: 14px;
}

@media (max-width: 620px) {
  .nav-link {
    padding-top: 0 !important;
    padding-left: 0 !important;
  }
}

.icon {
  content: url('/img/image/icon/menu.png');
}

.z-20 {
  z-index: 20;
}

.menu-mask {
  position: fixed;
  top: 0;
  left: 0;
  background: #00000066;
  width: 100%;
  height: 100%;
  z-index: 8000;
}


.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 295px;
  background-image: url('/img/image/background/bg_s3.png');
  ackground-size: cover;
  background-position: center;
  background-repeat: repeat;
  z-index: 9000;
}

.menu-items {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.menu-items a {
  color: white;
  font-size: 18px;
  font-weight: 500;

  text-decoration: none;
  width: 180px;
  text-align: center;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: #D56835 1px solid;
}


.bg-join {
  ackground-size: cover;
  background-position: center;
  background-repeat: repeat;
  background-image: url('/img/image/background/bg_s3.png');
}


.navbar-nav > .nav-item > .nav-link {
  font-size: 20px !important;
}

@media (max-width: 720px) {
  .navbar-nav > .nav-item > .nav-link {
    font-size: 18px !important;
  }
}

@media (max-width: 680px) {
  .navbar-nav > .nav-item > .nav-link {
    font-size: 14px !important;
  }
}


</style>
